import React, { useCallback, useState } from "react";

import { useDispatch } from "react-redux";

import { relayCreate } from "../store/relaysSlice.js";
import { RelayConfiguration } from "./RelayConfiguration.jsx";


export const AddRelay = () => {

    const dispatch = useDispatch();

    const [error, setError ] = useState(null);
    const [config, setConfig ] = useState({
        host: "",
        port: 17123,
        password: "",
        name: ""
    });

    const onAddRelay = useCallback(
        () => {
            dispatch(relayCreate(config.host, config.name, config.port, config.password)).then(() => {
                location.href="/#/";
    
            }, err => setError( err.message ))
        }, [ config ]
    )
   
    return (
        <div className="container">
            <div className="row">
                {
                    error ?
                        (
                            <div className="col-md-6 col-md-offset-3">
                                <div className="alert alert-danger" role="alert" id="error-message">{error}</div>
                            </div>
                        )
                        :
                        null
                }
            </div>
            <div className="row">
                <div className="col-md-10 col-md-offset-1">
                    <p>To connect to your relay you will require the following:</p>
                    <ul>
                        <li>A static IP address or dynamic DNS service.</li>
                        <li>Port forwarding configured to allow access to the relay&apos;s port (default is 17123)</li>
                        <li>Your relay must be configured to AES command set, and a password set</li>
                    </ul>
                </div>
            </div>
            <div className="row">

                <RelayConfiguration 
                    onChange={ setConfig } 
                    value={config} 
                    disabled={false} 
                    onSave={onAddRelay} 
                />
            </div>
        </div>
    );
}